(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('TaxClass', TaxClass);

    TaxClass.$inject = ['$resource'];

    function TaxClass ($resource) {
        var resourceUrl =  'api/tax-classes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
